import { FC, ReactNode } from 'react';

import { BodySmall, Box, Button, Tooltip } from '@parspec/pixel';

interface InfoCardProps {
    title: string;
    subTitle: string;
    helperText: string;
    isLoading: boolean;
    isOptionEnabled: boolean;
    isCardDisabled: boolean;
    onClickEnableDisableButton: () => void;
    icon: ReactNode;
    tooltipMsg?: string;
}

const InfoCard: FC<InfoCardProps> = ({ isLoading, isOptionEnabled, isCardDisabled, onClickEnableDisableButton, icon, title, subTitle, helperText, tooltipMsg }) => {

    return (
        <Box mt={4} maxWidth="50%">
            <BodySmall color="text.primary">{title}</BodySmall>
            <Tooltip title={tooltipMsg || ''}>
                <Box>
                    <Box mt={3} display="flex" border="1px solid " borderColor="neutral.main" borderRadius={1} justifyContent="space-between" alignItems="center" py={2} px={4} sx={isCardDisabled ? { opacity: '0.5', pointerEvents: 'none', backgroundColor: 'neutral.main', borderColor: 'neutral.light' } : {}}>
                        <Box display="flex" gap={2} alignItems="center">
                            <Box display="flex">
                                <Box color={isOptionEnabled ? 'secondary.contrastText' : 'neutral'}>{icon}</Box>
                            </Box>
                            <Box display="flex" flexDirection="column" justifyContent="space-between" gap={1}>
                                <Box>
                                    <BodySmall fontWeight={500}>{subTitle}</BodySmall>
                                </Box>
                                <Box>
                                    <BodySmall>{helperText}</BodySmall>
                                </Box>
                            </Box>
                        </Box>
                        <Box>
                            <Button onClick={onClickEnableDisableButton} color="primary" variant="text" sx={{ textWrap: 'noWrap' }} isLoading={isLoading} >
                                {isOptionEnabled ? 'Disable' : 'Enable'}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Tooltip>

        </Box>
    );
};

export default InfoCard;
